(() => {
  if (customElements.get('shelly-halloween-motion')) return;
  customElements.define('shelly-halloween-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.video) return;
      this.userPaused = false;
      this.active = !this.hasAttribute('data-lazy');
      this.mobilePreference = window.matchMedia('(max-width: 749px)');
      const update = () => {
        if (!this.button) return;
        this.button.hidden = this.preference.matches;
        this.button.textContent = this.video.paused ? 'הפעלת האנימציה' : 'עצירת האנימציה';
      };
      this.video.addEventListener('loadeddata', () => this.classList.add('sh-hw-video-ready'), { signal });
      this.video.addEventListener('playing', update, { signal });
      this.video.addEventListener('pause', update, { signal });
      this.video.addEventListener('error', () => { this.classList.remove('sh-hw-video-ready'); update(); }, { signal });
      if (this.button) this.button.addEventListener('click', () => {
        if (this.video.paused) { this.userPaused = false; this.startPlayback(); }
        else { this.userPaused = true; this.video.pause(); }
      }, { signal });
      this.preference.addEventListener('change', () => {
        if (this.preference.matches) this.video.pause();
        else if (!this.userPaused) this.startPlayback();
        update();
      }, { signal });
      this.mobilePreference.addEventListener('change', () => {
        if (!this.video.getAttribute('src')) return;
        this.video.pause();
        this.classList.remove('sh-hw-video-ready');
        this.selectSource();
        if (this.active && !this.preference.matches && !this.userPaused) this.startPlayback();
      }, { signal });
      update();
      if (this.active && !this.preference.matches) this.startPlayback();
    }
    selectSource() {
      const mobile = this.mobilePreference.matches && this.video.dataset.mobileSrc;
      const source = mobile || this.video.dataset.src;
      const poster = mobile ? this.video.dataset.mobilePoster : this.video.dataset.desktopPoster;
      if (poster) this.video.poster = poster;
      if (this.video.getAttribute('src') !== source) this.video.src = source;
    }
    activate() {
      this.active = true;
      if (!this.userPaused) this.startPlayback();
    }
    deactivate() {
      this.active = false;
      this.video.pause();
    }
    async startPlayback() {
      if (!this.active || this.preference.matches || !this.isConnected) return;
      this.video.muted = true;
      this.selectSource();
      try { await this.video.play(); }
      catch (_) { if (this.isConnected && this.button) this.button.textContent = 'הפעלת האנימציה'; }
    }
    disconnectedCallback() {
      if (this.video) this.video.pause();
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
})();
